import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-[100dvh] bg-black text-white/85">
      <header className="sticky top-0 z-10 bg-black/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center gap-4">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="h-10 w-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center active:scale-95 transition-transform"
            aria-label="Späť"
          >
            <ArrowLeft className="h-4 w-4 text-white" strokeWidth={1.8} />
          </Link>
          <div className="flex-1">
            <h1 className="font-display text-xl font-light tracking-tight">
              {title}
            </h1>
            {lastUpdated && (
              <p className="font-mono-label text-white/40 mt-0.5">
                Naposledy aktualizované · {lastUpdated}
              </p>
            )}
          </div>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-6 py-10 prose-legal">
        {children}

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-wrap gap-4 text-xs text-white/45">
          <Link to="/terms" className="hover:text-white transition-colors">
            Obchodné podmienky
          </Link>
          <span className="text-white/15">·</span>
          <Link to="/privacy" className="hover:text-white transition-colors">
            Ochrana osobných údajov
          </Link>
          <span className="text-white/15">·</span>
          <Link to="/cookies" className="hover:text-white transition-colors">
            Cookies & úložisko
          </Link>
          <span className="text-white/15">·</span>
          <a
            href="mailto:support@realselfie.eu"
            className="hover:text-white transition-colors"
          >
            support@realselfie.eu
          </a>
        </div>
      </article>
    </div>
  );
}
